import { render, staticRenderFns } from "./CollectionManage.vue?vue&type=template&id=20b22d43&scoped=true"
import script from "./CollectionManage.vue?vue&type=script&lang=js"
export * from "./CollectionManage.vue?vue&type=script&lang=js"
import style0 from "./CollectionManage.vue?vue&type=style&index=0&id=20b22d43&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b22d43",
  null
  
)

export default component.exports